import { defineMessages } from 'react-intl';

export const sideNavCreditUsagePopoverMessages = defineMessages({
  tooltip: {
    defaultMessage: 'Usage',
    id: 'APWYwO5Fic',
    description: 'Sidebar hover label for the credit usage popover trigger',
  },
  upgrade: {
    defaultMessage: 'Upgrade',
    id: 'voDUdFA7MB',
    description: 'Credit usage popover CTA when the Heidi 2 full upgrade flow is on',
  },
  trialDaysLeftTooltip: {
    defaultMessage: '{count, plural, one {# day} other {# days}} left on your trial',
    id: 'UbdCyDRDt3',
    description:
      'Sidebar hover label for the credit usage trigger while the user is on a trial with at least 1 day remaining',
  },
  clinicianTrialDaysLeftTooltip: {
    defaultMessage:
      '{count, plural, one {# day} other {# days}} left of your Clinician trial',
    id: 'yy2jLd9Vih',
    description:
      'Sidebar hover label for the credit usage trigger in the last week of a new user’s Heidi II Clinician trial',
  },
  complimentaryDaysLeftTooltip: {
    defaultMessage:
      '{count, plural, one {# day} other {# days}} left of complimentary usage',
    id: 'IE75USXTmZ',
    description:
      'Sidebar hover label for the credit usage trigger in the last week of complimentary Heidi II Max usage',
  },
  trialHoursLeftTooltip: {
    defaultMessage: '{count, plural, one {# hour} other {# hours}} left on your trial',
    id: 'SQjZ+lRY6l',
    description:
      'Sidebar hover label for the credit usage trigger while the user is on a trial with under 24 hours remaining',
  },
});
